import React from 'react'

import styles from './WarningMessage.css'

const WarningMessage = (props) => (
  <div>
    <div className={`alert ${styles['alert-orange']}`} role='alert'>
      <img src={require('./warning-icon.png')} />
      {props.children}
    </div>
  </div>
)

export default WarningMessage



// WEBPACK FOOTER //
// ./app/components/WarningMessage/WarningMessage.js